import React from 'react';

import './LegalPage.less';
import { colors, fonts } from 'screens/Editorial/theme';
import logoWhite from 'assets/landing/lyfe-logo-white.png';
import Seo from 'components/Seo';

// Shared renderer for legal pages (Privacy Policy, Terms). `content` is an
// ordered list of blocks — title / date / heading / paragraph — imported
// verbatim from the previous lyfe-social.com site. Paragraphs keep their
// embedded line breaks (numbered/bulleted lines) via white-space: pre-line.
export default function LegalPage({ content, seoTitle, seoDescription, path, fallbackTitle }) {
  const title = content.find((b) => b.type === 'title');
  const date = content.find((b) => b.type === 'date');
  const body = content.filter((b) => b.type === 'heading' || b.type === 'p');

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        minHeight: '100vh',
        overflowX: 'hidden',
        background: colors.bg,
        color: colors.ink,
        fontFamily: fonts.sans,
      }}>
      <Seo title={seoTitle} description={seoDescription} path={path} image="/assets/og-image.png" />

      {/* TOP BAR */}
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 30,
          background: 'rgba(10,10,12,.78)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          borderBottom: '1px solid rgba(255,255,255,.07)',
        }}>
        <div
          style={{
            maxWidth: 820,
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '18px 24px',
          }}>
          <a
            className="g-back"
            href="/"
            style={{ display: 'inline-flex', alignItems: 'center', gap: 9, color: '#B9B9C0', textDecoration: 'none', fontSize: 14 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Back to Lyfe
          </a>
          <img src={logoWhite} alt="Lyfe" style={{ height: 20, display: 'block', opacity: 0.92 }} />
        </div>
      </div>

      {/* CONTENT */}
      <div style={{ maxWidth: 820, margin: '0 auto', padding: '64px 24px 120px' }}>
        <h1
          style={{
            fontFamily: fonts.serif,
            fontWeight: 300,
            fontSize: 'clamp(36px,6vw,58px)',
            lineHeight: 1.04,
            letterSpacing: '-.015em',
          }}>
          {title ? title.text : fallbackTitle}
        </h1>
        {date && <div style={{ color: colors.muted2, fontSize: 15, marginTop: 14 }}>{date.text}</div>}

        <div style={{ marginTop: 40 }}>
          {body.map((b, i) =>
            b.type === 'heading' ? (
              <h2
                key={i}
                style={{
                  fontFamily: fonts.serif,
                  fontWeight: 400,
                  fontSize: 'clamp(22px,3vw,28px)',
                  lineHeight: 1.2,
                  letterSpacing: '-.01em',
                  color: colors.ink,
                  margin: '44px 0 4px',
                }}>
                {b.text}
              </h2>
            ) : (
              <p
                key={i}
                style={{
                  fontSize: 16,
                  lineHeight: 1.7,
                  color: colors.muted,
                  margin: '16px 0 0',
                  whiteSpace: 'pre-line',
                }}>
                {b.text}
              </p>
            )
          )}
        </div>
      </div>
    </div>
  );
}
